export enum HANA_SPACE_STATUS {
  ADDED = 'Added',
  DISCOVERED = 'Discovered',
  NOT_FOUND = 'Not Found',
}

export const HANA_STATUS_COLUMN_WIDTH = 150;
export const SPACE_LOOKUP_DEFAULT_PAGE = 1;
export const SPACE_LOOKUP_DEFAULT_LIMIT = 20;
export const SPACE_LOOKUP_SEARCH_DEBOUNCE_MS = 400;
export const SPACE_LOOKUP_MIN_SEARCH_LENGTH = 2;
export const AUTOCOMPLETE_INPUT_CHANGE_REASON_INPUT = 'input';
export const AUTOCOMPLETE_INPUT_CHANGE_REASON_CLEAR = 'clear';
